import * as React from 'react';
import { Form, Input, Button, Divider, message, Spin, Row, Col } from 'antd';
import { PageProps } from "../../models/common/ComponentProps";
import { LocalizeContextProps } from 'react-localize-redux';
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import SchoolFullSyncDTO from 'src/models/school/SchoolFullSyncDTO';
import SchoolApiController from 'src/api/SchoolApiController';
import DistrictApiController from 'src/api/DistrictApiController';
import { Link } from 'react-router-dom';
import UpdateDistrictDTO from 'src/models/district/UpdateDistrictDTO';
import TableRequestDTO from 'src/models/datatable/TableRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import DataTable, { DataTableColumnProps, DataTableButtonReset } from 'src/components/common/DataTable';
import { NameOf } from 'src/utils/NameOf';

interface RouteParams {
    id: string;
    districtId: string;
}

interface SyncResultsProps extends PageProps<RouteParams>, LocalizeContextProps {
}

interface SyncResultsState {
    loading: boolean;
    district: UpdateDistrictDTO;
}

class SyncResults extends React.Component<SyncResultsProps, SyncResultsState> {
    constructor(props: SyncResultsProps) {
        super(props);
        bindAllOfThis(this, SyncResults.prototype);

        this.state = {
            loading: true,
            district: {} as UpdateDistrictDTO,
        };
    }

    componentDidMount() {
        let districtId = parseInt(this.props.match.params.districtId, 10);

        if (districtId) {
            DistrictApiController.getDistrict(districtId).then((result) => {
                if (!result.ok) {
                    return;
                }

                this.setState({
                    loading: false,
                    district: result.data
                });
            }).catch(e => {
                message.error(this.props.translate('admin.addEditDistrict.messageRetrieveError'));
            });
        }
    }

    private fetchData(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<SchoolFullSyncDTO>) => void): void {
        let syncId = parseInt(this.props.match.params.id, 10);
        this.setState({ loading: true });

        SchoolApiController.getSchoolFullSyncTableData(requestState, syncId)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                this.setState({
                    loading: false
                });
                callback(results.data);
            });
    }

    private customTableColumns(): DataTableColumnProps<SchoolFullSyncDTO>[] {
        return [
            DataTable.AdvancedColumns.Text('School Name', 'name'),
            DataTable.AdvancedColumns.Number('Total Students', 'studentsCount'),
            DataTable.AdvancedColumns.Number('Total Teachers', 'teachersCount'),
        ];
    }

    render() {
        return (
            <div className="sync-results-container">
                <h2>Full Sync Results</h2>
                <h3>{this.state.district.districtName}</h3>
                <Link className="back-to-client-report" to={Routes.getRoute(Routes.ADMIN_ADD_EDIT_CLIENT, this.state.district.clientId)}>Back to Client Report</Link>

                <DataTable
                    serverSide={true}
                    tableProps={{ rowKey: 'districtId', loading: this.state.loading }}
                    columns={this.customTableColumns()}
                    data={[]}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButtonReset()
                    ]} />
            </div>
        );
    }
}

export default SyncResults;



// WEBPACK FOOTER //
// ./src/pages/admin/AdminSyncResults.tsx